import React, { Component } from "react";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import API from "../../actions";
import Table from '../Common/table';
import moment from "moment";

class SMSYearToDate extends Component {
    state = {
        ytdData: [],
        dialogOpen: false,
        sortColumn: { path: "nameFirst", order: "asc" }
    }
    columns = [
        { path: "month", label: "Måned", type: "alpha", sorting: false },
        { path: "freeTexts", label: "Gratis pr. Måned", type: "alpha", sorting: false },
        { path: "sent", label: "Sendt i denne måned", type: "alpha", sorting: false },
        { path: "tobeChanged", label: "At blive opladt", type: "alpha", sorting: false },
    ];

    componentWillReceiveProps(nextProps) {
        // if (nextProps.dialogOpen && nextProps.company.id !== this.props.company.id) {
        if (nextProps.dialogOpen && nextProps.company.id) {
            this.setState({ users: [] });
            this.getData(nextProps.company.id);
        }
    }

    async getData(id) {
        if (id) {
            try {
                const data = await API.getCompanyYTD(id);
                const freeTexts = data.freeTexts.split(',');
                const sentBooking = data.sentBooking.split(',');
                const sentCourse = data.sentCourse.split(',');
                let ytdData = [
                    { id: 'December', month: 'December', freeTexts: 0, sent: 0, tobeChanged: 0 },
                    { id: 'November', month: 'November', freeTexts: 0, sent: 0, tobeChanged: 0 },
                    { id: 'Oktober', month: 'Oktober', freeTexts: 0, sent: 0, tobeChanged: 0 },
                    { id: 'September', month: 'September', freeTexts: 0, sent: 0, tobeChanged: 0 },
                    { id: 'August', month: 'August', freeTexts: 0, sent: 0, tobeChanged: 0 },
                    { id: 'Juli', month: 'Juli', freeTexts: 0, sent: 0, tobeChanged: 0 },
                    { id: 'Juni', month: 'Juni', freeTexts: 0, sent: 0, tobeChanged: 0 },
                    { id: 'Maj', month: 'Maj', freeTexts: 0, sent: 0, tobeChanged: 0 },
                    { id: 'April', month: 'April', freeTexts: 0, sent: 0, tobeChanged: 0 },
                    { id: 'Marts', month: 'Marts', freeTexts: 0, sent: 0, tobeChanged: 0 },
                    { id: 'Februar', month: 'Februar', freeTexts: 0, sent: 0, tobeChanged: 0 },
                    { id: 'Januar', month: 'Januar', freeTexts: 0, sent: 0, tobeChanged: 0 },
                ];

                const curMonth = moment.utc().month() + 1;
                const curYear = moment.utc().year();
                console.log()
                if (curMonth < 11) {
                    ytdData = ytdData.slice(-1 * curMonth).concat(ytdData.slice(0, -1 * curMonth));
                }

                ytdData.map((o, i) => {
                    o.freeTexts = parseInt(freeTexts[i]);
                    o.sent = parseInt(sentBooking[i]) + parseInt(sentCourse[i]);
                    o.tobeChanged = (o.sent > o.freeTexts) ? o.sent - o.freeTexts : 0;
                    o.month += (i < curMonth) ? ' ' + curYear : ' ' + (curYear - 1);
                    return o;
                });

                this.setState({ ytdData });
            } catch (ex) {
                console.log(ex);
            }
        }
    }

    handleSort = sortColumn => {
        this.setState({ sortColumn });
    };

    render() {
        const { ytdData, sortColumn } = this.state;
        const { dialogOpen, onClose } = this.props;
        return (
            <div>
                <Dialog maxWidth="md" open={dialogOpen} aria-labelledby="form-dialog-title">
                    <form method="post" className="form-movie" onSubmit={this.handleSubmit}>

                        <DialogTitle id="form-dialog-title">SMS Year to date</DialogTitle>
                        <DialogContent>
                            <div className="table-responsive">
                                <Table
                                    columns={this.columns}
                                    onSort={this.handleSort}
                                    sortColumn={sortColumn}
                                    data={ytdData}
                                    handleSwitchChange={this.handleSwitchChange}
                                />
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={onClose} color="primary">Luk</Button>
                        </DialogActions>
                    </form>

                </Dialog>
            </div>
        );
    }
}

export default SMSYearToDate;
